var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{ref:"input",attrs:{"placeholder":"请从素材库上传并复制链接至此"},domProps:{"value":_vm.data}})])}
var staticRenderFns = []

export { render, staticRenderFns }